import { getUrlKey, isMobile } from "@/util/util";

export default {
    data() {
        return {
            info: {},
            params: {},
            type: 1,            // 1 福利 2 应援
            id: 0,
            percentage: 0,
        }
    },

    created() {
        this.type = getUrlKey('type',location.href) ?? 0;
        this.id = getUrlKey('id',location.href) ?? 0;
        if(isMobile()) {
            location.href = this.$link + '/active/detail?id=' + this.id + '&activeType=' + this.type
            // location.href = this.$link + '/active/detail?id=33&type=share&activeType=1'
        }
        this.getActiveDetail();
    },

    methods: {
        openIndex() {
            this.$router.push({
                name: 'active'
            })
        },

        openPop() {
            if(this.info.status !== 2) {
                return;
            }
            this.$MessageBox.confirm(
                '参与活动需要在手机APP内操作，点击确定将跳转APP下载页',
                '提示').then(res => {
                this.$router.push({
                    name: 'download'
                })
            })
        },

        // 获取活动详情
        getActiveDetail() {
            this.$post('api.php/Home/activityInfo',{
                id: this.id,
                type: this.type
            }).then(res => {
                if(res.status == 1) {
                    let data = res.data || {};
                    let name = this.type == 1 ? '福利' : '应援';
                    document.title = data.title + '-' + name + '- 文娱中国';
                    this.info = data;
                    if(this.type === 2) {
                        this.percentage = (data.raise_count / data.target) * 100;
                    }
                }
            })
        }
    }
}
